<template>
  <div class="accessad-page">
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :searchData="accessadSearchData"
      :isHaveExport="false"
      :isHaveAdd="false"
      :sizes="[10, 20, 50, 100]"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
    >
      <template #table>
        <AccessadTable :list="list" :loading="loading" />
      </template>
    </tableComponents>
  </div>
</template>

<script>
import AccessadTable from "./components/AccessadTable.vue";

function createDefaultQueryForm() {
  return {
    page_size: 20,
    user_id: "",
    trans_id: "",
    ad_tag: "",
    name: "",
    accounting: "",
    mediation_rit: "",
    prime_rit: "",
    type: "",
    start_time: "",
    end_time: "",
  };
}

export default {
  components: {
    AccessadTable,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      queryForm: createDefaultQueryForm(),
      paginationForm: {
        page: 1,
        page_size: 20,
      },
    };
  },
  computed: {
    accessadSearchData() {
      return () => [
        {
          title: "",
          type: "1",
          data: [
            {
              type: "date",
              arr: [],
              key: ["start_time", "end_time"],
              placeholder: "回调时间",
            },
          ],
        },
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "user_id", placeholder: "搜索用户ID" },
            { type: "text", key: "trans_id", placeholder: "搜索 Trans ID" },
            { type: "text", key: "ad_tag", placeholder: "搜索广告标签" },
            { type: "text", key: "name", placeholder: "搜索广告名称" },
            { type: "text", key: "mediation_rit", placeholder: "搜索 Mediation RIT" },
            { type: "text", key: "prime_rit", placeholder: "搜索 Prime RIT" },
            {
              type: "select",
              key: "accounting",
              option: [
                { id: "1", title: "已分佣" },
                { id: "0", title: "分佣失败" },
              ],
              placeholder: "分佣状态",
              onChange: () => {},
            },
            {
              type: "select",
              key: "type",
              option: [
                { id: "奖励", title: "奖励" },
                { id: "插屏", title: "插屏" },
                { id: "开屏", title: "开屏" },
                { id: "信息流", title: "信息流" },
              ],
              placeholder: "广告类型",
              onChange: () => {},
            },
          ],
        },
      ];
    },
  },
  methods: {
    resetCursorState() {
      this.total = 0;
      this.list = [];
    },
    getEffectiveParams() {
      const params = {
        ...this.queryForm,
        page: this.paginationForm.page,
        page_size: this.paginationForm.page_size,
      };

      if (this.$route.query.user_id && !params.user_id) {
        params.user_id = this.$route.query.user_id;
      }

      return params;
    },
    async getAccessadList() {
      this.loading = true;
      try {
        const data = await this.$api.getAccessad.getAccessadList(this.getEffectiveParams());
        this.list = data.data && Array.isArray(data.data.list) ? data.data.list : [];
        this.total = Number(data.data && data.data.count) || 0;
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getAccessadList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getAccessadList();
    },
    getSearch(form) {
      this.queryForm = {
        ...createDefaultQueryForm(),
        ...form,
      };
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getAccessadList();
    },
  },
  created() {
    if (this.$route.query.user_id) {
      this.queryForm.user_id = this.$route.query.user_id;
    }
    this.getAccessadList();
  },
  watch: {
    $route() {
      this.queryForm = createDefaultQueryForm();
      if (this.$route.query.user_id) {
        this.queryForm.user_id = this.$route.query.user_id;
      }
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getAccessadList();
    },
  },
};
</script>
